module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyLink":"Copy link","copied":"Link was copied"}}')
  delete Component.options._Ctor
}
